import React from 'react'
import { Translate } from 'react-redux-i18n'
import { formatCurrency, formatProfitLoss } from '../lib/currency-formatter'
import { calculateNextPaymentDate } from '@bdswiss/mt4-connector'
import { CouponInfo, BondTrade } from '../types'
import moment from 'moment'

export interface Props {
  accountLoaded: boolean
  position: BondTrade
  currency: string
  locale: string
  onClose: () => void
  tradeOperationEnabled: boolean
}

export interface State {
  dirty: boolean
  takeProfit: number
  stopLoss: number
}

class BondPosition extends React.Component<Props, State> {
  public render() {
    const { onClose, tradeOperationEnabled, currency, locale } = this.props
    const { trade, bond, coupons } = this.props.position
    const nextPaymentDate = calculateNextPaymentDate(bond)
    const nextPaymentDateFormatted = nextPaymentDate ? moment(nextPaymentDate).format('L') : '-'
    const paidInterest = coupons.reduce(
      (acc: number, coupon: CouponInfo) => (acc += coupon.amount),
      0
    )
    const accruedInterest = (bond.accruedInterest / bond.faceValue) * trade.volume
    const positionPL = ((bond.bid - 100 * trade.openPrice) * trade.volume) / 100

    return (
      <div className="edit-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <table className="edit-wrapper__table">
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <u className="color-75">
                        <Translate value={'positionDetails'} />
                      </u>
                    </td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'orderId'} />
                    </td>
                    <td>{trade.order}</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'value'} />
                    </td>
                    <td>
                      {formatCurrency((trade.volume * bond.bid) / 100, bond.currency, locale)}
                    </td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'leverage'} />
                    </td>
                    <td>{bond.leverage}X</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'openPrice'} />
                    </td>
                    <td>{formatCurrency(trade.openPrice * 100, bond.currency, locale)}</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'currentPrice'} />
                    </td>
                    <td>{formatCurrency(bond.bid, bond.currency, locale)}</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'profit'} />
                    </td>
                    <td className={positionPL > 0 ? 'positive' : 'negative'}>
                      {formatProfitLoss(positionPL, currency, locale)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="sidebar__label">
                      <u className="color-75">
                        <Translate value={'interestDetails'} />
                      </u>
                    </td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'principalAmount'} />
                    </td>
                    <td>{formatCurrency(trade.volume, bond.currency, locale)}</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'coupon'} />
                    </td>
                    <td>{bond.couponInterestRate}%</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'nextInterestPayment'} />
                    </td>
                    <td>{nextPaymentDateFormatted}</td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'accruedInterest'} />
                    </td>
                    <td className="positive">
                      {formatCurrency(accruedInterest, currency, locale)}
                    </td>
                  </tr>
                  <tr>
                    <td className="pl-3">
                      <Translate value={'paidInterest'} />
                    </td>
                    <td className="positive">{formatCurrency(paidInterest, currency, locale)}</td>
                  </tr>

                  <tr>
                    <td colSpan={2}>
                      <sup className="bondBuyModeDisclamer">
                        <Translate value={'interestPaymentNote'} />
                      </sup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="d-flex col justify-content-between mt-3">
              <button
                onClick={onClose}
                className="btn btn-danger col-12"
                disabled={!tradeOperationEnabled}
                data-cy="sellBond"
              >
                <Translate value={'sell'} />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BondPosition
